/**
 * @author       calvin@zumper.com (Calvin Yau)
 * @copyright    Copyright (c) 2023, Zumper
 * @description  transform '/' to '&'
 */

export const transformSlashesToAmpersand = (transformString: string) => {
  const numSlashes = transformString.match(/\//g)?.length ?? 0
  if (numSlashes === 1) {
    return transformString.replace(/\s*\/\s*/, ' & ')
  } else if (numSlashes > 1) {
    const commaSwapped = transformString.replace(/\s*\/\s*/g, ', ')
    const lastComma = commaSwapped.lastIndexOf(', ')
    return commaSwapped.slice(0, lastComma) + ', & ' + commaSwapped.slice(lastComma + 2)
  }
  return transformString
}
